/**
 * ODL v41 — coloris sur les cartes produits (snippets/odl-card-coloris.liquid).
 * Au survol d'une vignette à la souris, la photo principale de la carte passe sur ce coloris ;
 * elle revient à l'originale quand la souris quitte la rangée de vignettes.
 * Module : chargé et exécuté une seule fois même si chaque carte l'appelle.
 */
const CARD = 'product-card, .odhq__card';
const IMG = '.card-gallery img, .odhq__media img';

function cardImage(el) {
  const card = el.closest(CARD);
  return card ? card.querySelector(IMG) : null;
}

function swap(dot) {
  const url = dot.dataset.img;
  const img = cardImage(dot);
  if (!url || !img) return;
  if (!img.dataset.odccSrc) {
    img.dataset.odccSrc = img.getAttribute('src') || '';
    img.dataset.odccSet = img.getAttribute('srcset') || '';
  }
  img.removeAttribute('srcset');
  img.src = url;
}

function restore(box) {
  const img = cardImage(box);
  if (!img || !img.dataset.odccSrc) return;
  img.src = img.dataset.odccSrc;
  if (img.dataset.odccSet) img.setAttribute('srcset', img.dataset.odccSet);
  delete img.dataset.odccSrc;
  delete img.dataset.odccSet;
}

if (!window.__odlCardColoris && window.matchMedia('(hover: hover)').matches) {
  window.__odlCardColoris = true;

  document.addEventListener('mouseover', (event) => {
    const dot = event.target instanceof Element ? event.target.closest('.odcc__dot') : null;
    if (dot) swap(dot);
  });

  document.addEventListener('mouseout', (event) => {
    const box = event.target instanceof Element ? event.target.closest('.odcc') : null;
    if (!box) return;
    if (event.relatedTarget instanceof Node && box.contains(event.relatedTarget)) return;
    restore(box);
  });
}
